[
  {
    "id": "ben",
    "title": "C:\\BEN",
    "address": "C:\\BEN",
    "paragraphs": [
      "A folder that is mostly other folders.",
      "Games, experiments, and a lot of beige plastic.",
      "Open Projects from the Start menu if you want the short list."
    ]
  },
  {
    "id": "recycle",
    "title": "Recycle Bin",
    "address": "C:\\RECYCLED",
    "paragraphs": [
      "It is empty. For now."
    ]
  },
  {
    "id": "liqueef",
    "title": "Liqueef — OmniGrunt Nutrition Division",
    "address": "http://omnigrunt.internal/liqueef",
    "paragraphs": [
      "LIQUEEF: it goes down like regret and stays down like regret.",
      "Viscosity Max. Neuro-Buzz Formula. Approved for night-shift consumption only.",
      "An OmniGrunt product. Hope is a renewable resource. So is sludge."
    ]
  },
  {
    "id": "debtease",
    "title": "DebtEase — A Better Tomorrow, Financed",
    "address": "http://omnigrunt.internal/debtease",
    "paragraphs": [
      "Missed a Volunteer Quota? DebtEase can help.",
      "Consolidate your remaining organs, NutriPaste stipend, and Entertainment Tax into one easy payment — or one appearance on Wrack 'n Crack.",
      "Hope is a payment plan. An OmniGrunt financial product."
    ]
  }
]
